module.exports = __webpack_public_path__ + "aef7ebaa.png";